<ng-container *ngIf="embedded">
  <ol class="fulfillment-timeline" *ngIf="orderedActivities.length">
    <li
      *ngFor="let activity of orderedActivities; let index = index"
      class="fulfillment-step"
      [class.completed]="isCompletedStep(index)"
      [class.current]="isCurrentStep(index)"
    >
      <div class="fulfillment-step-marker" aria-hidden="true">
        <mat-icon *ngIf="isCompletedStep(index)">check</mat-icon>
        <mat-icon *ngIf="isCurrentStep(index)">radio_button_checked</mat-icon>
      </div>
      <div class="fulfillment-step-content">
        <div class="fulfillment-step-title">{{ activity.status }}</div>
        <div
          class="fulfillment-step-meta"
          *ngIf="formatWhen(activity.date, activity.time) as when"
        >
          {{ when }}
        </div>
        <div
          class="fulfillment-step-detail"
          *ngIf="formatLocation(activity.city, activity.country) as location"
        >
          {{ location }}
        </div>
      </div>
    </li>
  </ol>

  <p class="ups-tracking-timeline__empty" *ngIf="!orderedActivities.length">
    {{ "printCardOrders.shipmentTrackingHistoryEmpty" | translate }}
  </p>
</ng-container>

<section
  class="ups-tracking-timeline"
  *ngIf="!embedded && (trackingNumber || activities.length || shipmentDescription || shipmentCarrier)"
>
  <div class="fulfillment-header" *ngIf="!compact">
    <h2>{{ "printCardOrders.shipmentTrackingTitle" | translate }}</h2>
  </div>

  <div
    class="ups-meta ups-meta--row"
    *ngIf="!compact && (shipmentDescription?.trim() || trackingNumber || status || shipmentCarrier)"
  >
    <div class="ups-meta__item" *ngIf="shipmentCarrier">
      <span class="label">{{ "printCardOrders.shipmentCarrier" | translate }}</span>
      <span class="ups-meta__value">{{
        getShipmentCarrierLabelKey(shipmentCarrier) | translate
      }}</span>
    </div>
    <div class="ups-meta__item" *ngIf="shipmentDescription?.trim()">
      <span class="label">{{ "printCardOrders.shipmentDescription" | translate }}</span>
      <span class="ups-meta__value">{{ shipmentDescription }}</span>
    </div>
    <div class="ups-meta__item" *ngIf="trackingNumber">
      <span class="label">{{ "printCardOrders.trackingNumber" | translate }}</span>
      <span class="ups-meta__value">{{ trackingNumber }}</span>
    </div>
    <div class="ups-meta__item" *ngIf="status">
      <span class="label">{{ "printCardOrders.shipmentStatus" | translate }}</span>
      <span
        class="stage-badge"
        [attr.data-stage]="delivered ? 'DELIVERED' : 'IN_TRANSIT'"
      >
        {{ status }}
      </span>
    </div>
  </div>

  <button
    type="button"
    class="ups-history-toggle"
    *ngIf="historyCollapsible"
    [attr.aria-expanded]="showHistory"
    (click)="toggleHistory()"
  >
    <span class="ups-history-toggle__label">
      {{ "printCardOrders.shipmentTrackingHistory" | translate }}
      <span class="ups-history-toggle__count" *ngIf="orderedActivities.length">
        ({{ orderedActivities.length }})
      </span>
    </span>
    <mat-icon aria-hidden="true">{{ showHistory ? "expand_less" : "expand_more" }}</mat-icon>
  </button>

  <div class="ups-history-panel" *ngIf="showHistory || !historyCollapsible">
    <ol class="fulfillment-timeline" *ngIf="orderedActivities.length">
      <li
        *ngFor="let activity of orderedActivities; let index = index"
        class="fulfillment-step"
        [class.completed]="isCompletedStep(index)"
        [class.current]="isCurrentStep(index)"
      >
        <div class="fulfillment-step-marker" aria-hidden="true">
          <mat-icon *ngIf="isCompletedStep(index)">check</mat-icon>
          <mat-icon *ngIf="isCurrentStep(index)">radio_button_checked</mat-icon>
        </div>
        <div class="fulfillment-step-content">
          <div class="fulfillment-step-title">{{ activity.status }}</div>
          <div
            class="fulfillment-step-meta"
            *ngIf="formatWhen(activity.date, activity.time) as when"
          >
            {{ when }}
          </div>
          <div
            class="fulfillment-step-detail"
            *ngIf="formatLocation(activity.city, activity.country) as location"
          >
            {{ location }}
          </div>
        </div>
      </li>
    </ol>

    <p class="ups-tracking-timeline__empty" *ngIf="!orderedActivities.length">
      {{ "printCardOrders.shipmentTrackingHistoryEmpty" | translate }}
    </p>
  </div>
</section>
